import { User } from '@/modules/user/user';

export class PvLog {

    public static validate(): string[] {
        return [];
    }
    public id!: string;
    public eventType!: string;
    public userId!: string;
    public date!: Date;
    public createdAt!: Date;
    public updatedAt!: Date;
    public createdBy?: User;
    public updatedBy?: User;

    public user?: User;

    constructor(opt: any) {
        Object.assign(this, opt);

        this.date = new Date(this.date);
        this.createdAt = new Date(this.createdAt);
        this.updatedAt = new Date(this.updatedAt);

        if (this.user) {
            this.user = new User(this.user);
        }
    }
}
